<template>
  <div class="horizontal items-center justify-between slider-wrap relative"
      :style="{'--itemOffset': sliderStyle.itemOffset, '--itemWidth': sliderStyle.itemWidth, '--itemColor': sliderStyle.itemColor,
       '--itemShadowColor': sliderStyle.shadowColor, '--itemInsetShadowColor': sliderStyle.insetShadowColor, 'opacity': disabled ? 0.3:1}">
    <div class="active">

    </div>
    <div v-for="(item,index) in mode" :ref="'sliderItem'+index" class="slider-item"
        :class="index === selectedItem ? 'slider-item-active': ''"
        @click="onItemClick(item,index)">{{ item.name }}
    </div>

  </div>
</template>

<script>
export default {
  name: "NicoSlider",
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    selectedItem: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      mode: [
        { name: "LIGHT", color: "#BBD93E", shadowColor: "#A6C131", insetShadowColor: "#E4FD7E" },
        { name: "SMOOTH", color: "#52A7C4", shadowColor: "#56A9C5", insetShadowColor: "#88E0FF" },
        { name: "STRONG", color: "#DC4D31", shadowColor: "#CB452B", insetShadowColor: "#FC866F" }
      ],
      sliderStyle: {
        itemOffset: 0,
        itemWidth: 0,
        itemColor: "#BBD93E",
        shadowColor: "#A6C131",
        insetShadowColor: "#E4FD7E"
      }
    };
  },
  methods: {
    onItemClick(item, index) {
      if (this.disabled) {
        return;
      }
      if (index === this.selectedItem) {
        return;
      }
      // this.selectedItem = index;

      this.$emit("click", index);
    },
    calcSize() {
      this.mode.forEach((item, index) => {
        item.clientWidth = this.$refs[`sliderItem${index}`][0].clientWidth;
        item.offsetLeft = this.$refs[`sliderItem${index}`][0].offsetLeft;
        console.log(`width = ${item.clientWidth} offsetLeft = ${item.offsetLeft}`);
        if (index === 0) {
          this.sliderStyle.itemWidth = `${item.clientWidth}px`;
        }
      });
    }
  },
  watch: {
    selectedItem(val) {
      console.log(`选中移动曲线` ,val);
      const item = this.mode[val];
      this.sliderStyle = {
        itemOffset: `${item.offsetLeft - 6}px`,
        itemWidth: `${item.clientWidth}px`,
        itemColor: item.color,
        shadowColor: item.shadowColor,
        insetShadowColor: item.insetShadowColor
      };
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.calcSize();
    });
    window.addEventListener("resize", this.calcSize);
  },
  destroyed() {
    window.removeEventListener("resize", this.calcSize);
  }
};
</script>


<style scoped lang="less">
.slider-wrap {
  text-align: center;
  background: #090909;
  box-shadow: inset 0px 0px 3px 0px rgba(171, 171, 171, 0.3), inset 0px 0px 10px 10px rgba(73, 73, 73, 0.6);
  font-family: 'outfit';
  font-size: 18px;
  font-weight: 500;
  min-height: 46px;
  border-radius: 50px;
  padding: 0 6px;
}

.slider-item {
  width: 100%;
  padding: 6px 0;
  z-index: 100;
  color: white;
}

.slider-item-active {
  padding: 6px 0;
  z-index: 100;
  color: black;
  transition: color 1s ease-in-out;
}

.active {
  position: absolute;
  z-index: 1;
  border-radius: 50px;
  min-width: var(--itemWidth);
  min-height: 40px;
  color: black;
  background: var(--itemColor);
  transform: translateX(var(--itemOffset));
  box-shadow: 0px 3px 10px 0px var(--itemShadowColor), inset 0px 4px 10px 0px var(--itemInsetShadowColor);
  transition: all 0.5s ease-in-out;
}
</style>